import React, {Fragment} from "react";

const CardStatistics = props => {
    return (
        <div className={ ['card-statistics' , props.status ?  props.status : "" ].join(" ") }>
            <h4>{props.title}</h4>
            <strong>{props.value}</strong>
        </div>
    );
};

export default CardStatistics;